@if (promptService.message(); as message) {
  <div
    class="fixed inset-0 z-50 flex items-center justify-center bg-ink/40 px-4"
    (click)="promptService.hide()"
  >
    <div
      class="w-full max-w-sm rounded-2xl bg-cream p-6 text-center shadow-xl"
      (click)="$event.stopPropagation()"
    >
      <h2 class="font-display text-xl font-semibold text-ink">Join Galopa</h2>
      <p class="mt-2 text-sm text-ink/70">{{ message }}</p>

      <div class="mt-6 flex flex-col gap-2">
        <button
          type="button"
          class="cursor-pointer rounded-full bg-rose px-4 py-2.5 text-sm font-medium text-cream transition hover:opacity-90"
          (click)="goToSignup()"
        >
          Sign up free
        </button>
        <button
          type="button"
          class="cursor-pointer rounded-full border border-line px-4 py-2.5 text-sm font-medium text-ink transition hover:bg-creamdark"
          (click)="goToLogin()"
        >
          Log in
        </button>
        <button
          type="button"
          class="cursor-pointer mt-1 text-sm text-ink/60 hover:text-ink"
          (click)="promptService.hide()"
        >
          Continue browsing
        </button>
      </div>
    </div>
  </div>
}
